<ng-container *ngIf='!accessDenied'>
    <div *ngIf='!loader' class="w-100 float-left">
        <div class="w-100 float-left v-align relative" *ngIf='mainPage'>
            <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
                <h5 class="medium m-0">DATA SOURCE</h5>
                <div style="flex-grow: 1;"></div>
                <div class="btn-group" ngbDropdown role="group" aria-label="Button group with nested dropdown">
                    <button class="btn btn-primary dropdown-toggle-split" ngbDropdownToggle> Add Connection To</button>
                    <div class="dropdown-menu" ngbDropdownMenu>
                        <a class="dropdown-item primary" (click)="addNewDataSource('FILE_S3')">S3 Storage</a>
                        <a class="dropdown-item primary" (click)="addNewDataSource('FILE_SFTP')">SFTP</a>
                        <a class="dropdown-item primary" (click)="addNewDataSource('FILE_DFS')">File System</a>
                        <a class="dropdown-item primary" (click)="addNewDataSource('MONGO')">Mongo</a>
                        <!-- <a class="dropdown-item primary" (click)="addNewDataSource('DRILL_HIVE')">Hive via DRILL</a>
                        <a class="dropdown-item primary" (click)="addNewDataSource('DRILL_HBASE')">Hbase via DRILL</a> -->
                        <a class="dropdown-item primary" (click)="addNewDataSource('MYSQL')">MYSQL</a>
                        <a class="dropdown-item primary" (click)="addNewDataSource('HIVE')">Hive</a>
                        <a class="dropdown-item primary" (click)="addNewDataSource('REDIS')">Redis</a>
                        <a class="dropdown-item primary" (click)="addNewDataSource('REDSHIFT')">Redshift</a>
                        <a class="dropdown-item primary" (click)="addNewDataSource('KAFKA')">Kafka</a>
                        <a class="dropdown-item primary" (click)="addNewDataSource('MONGODB')">MongoDB</a>
                        <a class="dropdown-item primary" (click)="addNewDataSource('POSTGRESQL')">PostgreSQL</a>
                        <a class="dropdown-item primary" (click)="addNewDataSource('CASSANDRA')">Cassandra</a>
                        <a class="dropdown-item primary" (click)="addNewDataSource('SQLSERVER')">SQL Server</a>
                        <a class="dropdown-item primary" (click)="addNewDataSource('HBASE')">Project in Kylin</a>
                        <a class="dropdown-item primary" (click)="addNewDataSource('CLICK_HOUSE')">Clickhouse</a>

                    </div>
                </div>
                <!-- <button id="add" (click)="addNewDataSource()" class="btn btn-primary float-right mr-3"> Add Data Source </button> -->
            </div>
        </div>
        <div *ngIf='mainPage' class="main-table table-custom">
            <div class="w-100 float-left p-3 light-bg">
                <div class="col-lg-10 col-md-12 col-sm-12 col-xs-12 float-left p-2 align-v-center">
                    <input class="w-50 float-left form-control" name="searchBox" id="searchBox" #searchBox
                           maxlength="100" placeholder="Keywords"
                           type="text" ng-reflect-maxlength="100" ng-reflect-model="" [(ngModel)]="dataSourceReg">
                    <div>
                        <button id="Search" (click)="searchPDataSource()" class="btn btn-primary float-left">Search
                        </button>
                    </div>
                </div>
            </div>

            <div class="w-100 float-left mt-3" *ngIf='dataSourceList && dataSourceList.length'>
                <div class="light-bg w-100 float-left p-2 grid-details">
                    <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left" ngbTooltip="Code">
                        <h6 class="mb-lg-0 medium text-truncate"> Code </h6>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="Name">
                        <h6 class="mb-lg-0 medium text-truncate"> Name </h6>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="Catalog">
                        <h6 class="mb-lg-0 medium text-truncate"> Catalog </h6>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="Schema">
                        <h6 class="mb-lg-0 medium text-truncate"> Schema </h6>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="Username">
                        <h6 class="mb-lg-0 medium text-truncate"> Username </h6>
                    </div>
                    <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center" ngbTooltip="Actions">
                        <h6 class="mb-lg-0 medium text-truncate"> Actions </h6>
                    </div>
                </div>
            </div>
            <div class="w-100 float-left p-md-2 grid-details" *ngFor="let ds of dataSourceList;">

                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left" ngbTooltip="{{ds.dataSourceCode}}">
                    <h6 class="mb-lg-0 text-truncate"> {{ds.dataSourceCode}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="{{ds.name}}">
                    <h6 class="mb-lg-0 text-truncate"> {{ds.name}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="{{ds.catalog}}">
                    <h6 class="mb-lg-0 text-truncate"> {{ds.catalog}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="{{ds.schema}}">
                    <h6 class="mb-lg-0 text-truncate"> {{ds.schema}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="{{ds.username}}">
                    <h6 class="mb-lg-0 text-truncate"> {{ds.username}} </h6>
                </div>
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center" [id]="ds.id"
                     (mouseenter)=entityOps($event) (mouseleave)=closeDropDown($event)>
                    <h6 class="mb-lg-0">
                        <i class="fa fa-ellipsis-h"></i>
                    </h6>
                    <div class="empActions m-t-nsmd" style="top:29px" *ngIf="selectedSourceId==ds.id?true:false ">
                        <i class="fa fa-caret-up caret-up"></i>
                        <ul class="m-0 p-0">
                            <li (click)="clickEdit(ds)">
                                <i class="fa fa-pencil mr-2"> </i>Edit
                            </li>
                            <li *ngIf="ds.dataEngine && (ds.dataEngine.type=='PRESTO' || ds.dataEngine.type=='SSAS' || ds.dataEngine.type=='CLICK_HOUSE')"
                                (click)="syncDataSource(ds)">
                                <i class="fa fa-refresh mr-2"> </i>Sync Record Format
                            </li>
                            <li (click)="removeDataSource(ds)">
                                <i class="fa fa-trash mr-2"> </i>Delete
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
            <ng-container *ngIf='dataSourceList.length == 0'>
                <div class="w-100 float-left p-4 grid-details" *ngIf="!loader">
                    <p class="text-center m-0 w-100 medium">No Results Found</p>
                </div>
            </ng-container>

            <!-- PAGINATION -->
            <div class="w-100 float-left my-4 light-bg p-3 align-v-center">
                <h6 class="float-left mb-0 mr-4 text-truncate"> {{startingPage}} - {{endingPage}} of {{totalSource}}
                    items </h6>
                <div class="float-left ml-2 align-v-center">
                    <label class="m-0 float-left">Show items per page</label>
                    <select class="form-control float-left w-auto ml-2 mb-0" [(ngModel)]="pageSize"
                            (change)="OnPageSizeChanged($event)">
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                    </select>
                </div>
                <div style="flex-grow: 1;"></div>
                <ngb-pagination *ngIf='dataSourceList && dataSourceList.length' [collectionSize]="totalSource"
                                [rotate]="true" [maxSize]="5"
                                [pageSize]="pageSize" [ellipses]="false" [boundaryLinks]="true" [(page)]="currentPage"
                                (pageChange)="onPageChange($event)"
                                class="float-right"></ngb-pagination>
            </div>
        </div>
        <!-- ADDING OR UPDATING DATA SOURCE -->
        <div class="w-100 float-left" *ngIf='dataSourcePage'>
            <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
                <h5 class="medium m-0" *ngIf="!isEdit">Add Data Source </h5>
                <h5 class="medium m-0" *ngIf="isEdit">Edit Data Source - {{dataSourceData.dataSourceCode}}</h5>
                <div class="ml-alert"></div>
                <div style="flex-grow: 1;"></div>
                <button class="btn btn-secondary" (click)="onBack()">
                    <i class="fa fa-arrow-left mr-sm-2"></i> Back
                </button>
            </div>
            <div class="w-100 float-left mt-3">
                <div class='col-lg-6 col-md-6 float-left left-clear'>
                    <div class="form-group">
                        <label> Name
                            <span class="text-danger medium">*</span>
                        </label>
                        <input maxlength="200" type="text" class="form-control" [(ngModel)]="dataSourceData.name"
                               name="name"/>
                    </div>
                </div>
                <div class='col-lg-6 col-md-6 float-left'>
                    <div class="form-group">
                        <label>Type</label>
                        <input maxlength="200" type="text" class="form-control" [(ngModel)]="dataSourceData.type"
                               name="type"/>
                    </div>
                </div>
                <div class='col-lg-6 col-md-6 float-left left-clear'>
                    <div class="form-group w-100">
                        <label for="dropDown">Data Engine
                            <span class="text-danger medium">*</span>
                        </label>
                        <select class="form-control light-bg" (change)="confirmChangeOfEngine($event)">
                            <option value="none">None</option>
                            <option *ngFor="let engine of dataEngineList" [attr.value]='engine.id'
                                    [attr.selected]="dataSourceData.dataEngineId == engine.id ? true : null">
                                {{engine.name}}
                            </option>
                        </select>
                    </div>
                </div>
                <div *ngIf="!isSSaSS" class='col-lg-6 col-md-6 float-left'>
                    <div class="form-group">
                        <label> Catalog
                            <span class="text-danger medium">*</span>
                        </label>
                        <input maxlength="200" type="text" class="form-control" [(ngModel)]="dataSourceData.catalog"
                               name="catalog"/>
                    </div>
                </div>
                <div class='col-lg-6 col-md-6 float-left left-clear'>
                    <div class="form-group">
                        <label> Schema
                            <span class="text-danger medium">*</span>
                        </label>
                        <input maxlength="200" type="text" class="form-control" [(ngModel)]="dataSourceData.schema"
                               name="schema"/>
                    </div>
                </div>
                <div class='col-lg-6 col-md-6 float-left'>
                    <div class="form-group">
                        <label>Storage Type</label>
                        <input readonly maxlength="200" type="text" class="form-control"
                               [(ngModel)]="dataSourceData.storageType" name="storageType"/>
                    </div>
                </div>
                <div *ngIf="!isSSaSS" class='col-lg-6 col-md-6 float-left left-clear'>
                    <div class="form-group">
                        <label>Location
                            <span class="text-danger medium">*</span>
                        </label>
                        <input maxlength="200" type="text" class="form-control" [(ngModel)]="dataSourceData.location"
                               name="location"/>
                    </div>
                </div>
                <div *ngIf="isConnection" class='col-lg-6 col-md-6 float-left'>
                    <div class="form-group">
                        <label *ngIf="connectionLabel">{{connectionLabel}}</label>
                        <input maxlength="200" type="text" class="form-control" [(ngModel)]="dataSourceData.connection"
                               name="Connection"/>
                    </div>
                </div>
                <div *ngIf="!isSSaSS" class='col-lg-6 col-md-6 float-left left-clear'>
                    <div class="form-group">
                        <label> Username
                            <span class="text-danger medium">*</span>
                        </label>
                        <input maxlength="200" type="text" class="form-control" [(ngModel)]="dataSourceData.username"
                               name="username"/>
                    </div>
                </div>
                <div *ngIf="!isSSaSS" class='col-lg-6 col-md-6 float-left'>
                    <div class="form-group">
                        <label> Password
                            <span class="text-danger medium">*</span>
                        </label>
                        <input maxlength="200" type="password" class="form-control"
                               [(ngModel)]="dataSourceData.newPassword" name="password"/>
                    </div>
                </div>
                <div *ngIf="parameters && parameters.length != 0"
                     class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-left my-4 form-group">
                    <div class="w-100">
                        <div *ngFor="let parameter of parameters;index as i" class='col-lg-6 col-md-6 '
                             [ngClass]="((i+1)%2 ==0) ? 'float-left ' : 'float-left left-clear'">
                            <div class="form-group">
                                <label>{{parameter}}
                                    <span class="text-danger medium">*</span>
                                </label>
                                <input maxlength="200" type="text" class="form-control"
                                       [(ngModel)]="dataSourceData['customParameter'+(i+1)]"
                                       name="customParameter"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-3 float-right">
                    <button class="btn btn-primary float-right" [disabled]="saveButton" (click)="onSave()">Save</button>
                    <button class="btn btn-primary v-align relative" (click)="onTest()">Test Connection</button>
                </div>
            </div>
        </div>
    </div>
    <div class="w-100 float-left min-h2 relative" *ngIf="loader">
        <loader></loader>
    </div>
</ng-container>


// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/dataSource.component.html